import {styled} from '@mui/material/styles'
import Box from '@mui/material/Box'
import {CancelRounded} from '@mui/icons-material'

export const StyledRuleRow = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  color: theme.palette.hpBaseDarker,
  cursor: 'default'
}))

export const StyledRequirementIcon = styled(CancelRounded)(() => ({
  cursor: 'default',
  '&:hover': {
    cursor: 'default'
  }
}))
